import React from 'react';
import { Box, Link, Container, CssBaseline, useMediaQuery, useTheme, Grid } from '@mui/material';

const ComoCargarCupon = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container component="main" maxWidth="lg">
      <CssBaseline />
      <Box sx={{ display: 'flex' }}>
        {!isMobile && (
       <Box sx={{ width: '25%' }}>
       <Box sx={{ width: '100%', height: '70%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
       <img src='/img/jxjbannercontexto.jpg' alt="Juga por jugar" style={{ maxWidth: '100%', height: 'auto', position: 'absolute', top: '0%' }} />

            </Box>
       <Box sx={{ height: '30%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
         <Grid container spacing={2} sx={{ height: '100vh' }}>
           <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
             <img src='/img/jugaporjugar.png' alt="Juga por jugar" style={{ maxWidth: '100%', maxHeight: '80%' }} />
           </Grid>
         </Grid>
       </Box>
     </Box>
        )}
        <Box sx={{ width: isMobile ? '100%' : '75%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ height: '20vh', bgcolor: '#d7412a' }}>
            <h1 className='titulo2'>BASES Y CONDICIONES</h1>
          </Box>
          <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', pt: .5 }}>
          <img src={isMobile ? '/img/basesm.jpg' : '/img/basesw.jpg'} alt="Premios" style={{ maxWidth: '99%' }}  />
  {/* <img src='/img/basesy.png' alt="Juga por jugar" style={{ maxWidth: '99%' }} /> */}

  <Box sx={{ mt: 2 }}>
      <a href='/download/reglamento_bases_y_condiciones.pdf' download style={{ display: 'block', textAlign: 'center', marginTop: '1rem' }}>
        Bases y Condiciones
      </a>
      <a href="/download/formulario.pdf" download style={{ display: 'block', textAlign: 'center', marginTop: '1rem' }}>
        Formulario de Inscripción
      </a>
      <a href="/download/nota_cesion.pdf" download style={{ display: 'block', textAlign: 'center', marginTop: '1rem' }}>
        Nota de Cesión
      </a>
    </Box>
</Box>
          <Box sx={{ bgcolor: 'grey.100', p: 2 }}> 
            <h1 className='titulo1'>
              Por dudas y consultas envíanos un mail a: 
           <br />
                <a href="mailto:juegoresponsable@inprojuy.gob.ar">juegoresponsable@inprojuy.gob.ar</a>
          
              <Box sx={{ textAlign: 'center', marginTop: '10px' }}>
                <img src='/img/cine.png' alt="Descripción de la imagen" style={{ maxWidth: '100%' }} />
              </Box>
            </h1>      
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default ComoCargarCupon;
